import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { ServiceModalAction } from '../../actions/ServiceModalAction';
import { Translate as t } from '../../config/Translate';
import ServiceModalIssueAlert from './ServiceModalIssueAlert';
import ServiceModalNewTicket from './ServiceModalNewTicket';
import ServiceModalQueue from './ServiceModalQueue';
import { isAdminPathname } from '../../lib/isAdminPathname';

const ServiceModalPopup = ({ showModal, modalType, currentAlert, HideModal }) => {
	const location = useLocation();
	const isAdminPath = isAdminPathname(location.pathname);

	// BUG-077: Admin 경로 이탈 시 ISSUE_ALERT store 상태 자동 정리
	useEffect(() => {
		if (!isAdminPath && showModal && modalType === 'ISSUE_ALERT') {
			HideModal();
		}
	}, [isAdminPath, showModal, modalType]);

	if (!showModal) return null;
	// BUG-077: Issue Alert은 Admin 경로에서만 표시
	if (modalType === 'ISSUE_ALERT' && !isAdminPath) return null;

	const getTitle = () => {
		if (modalType === 'ISSUE_ALERT') return t('service.issueManager.issueAlertTitle');
		if (modalType === 'NEW_TICKET') return t('service.issueManager.newTicketTitle');
		return t('service.issueManager.alert');
	};

	const getSize = () => {
		return modalType === 'ISSUE_ALERT' ? 'lg' : 'md';
	};

	return (
		<Modal
			show={showModal}
			onHide={HideModal}
			size={getSize()}
			backdrop="static"
			keyboard={false}
			centered
		>
			<Modal.Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
				<Modal.Title style={{ fontSize: '16px' }}>{getTitle()}</Modal.Title>
				<button
					type="button"
					onClick={HideModal}
					aria-label="Close"
					style={{
						background: 'none',
						border: 'none',
						fontSize: '22px',
						lineHeight: 1,
						color: '#6c757d',
						cursor: 'pointer',
						padding: '4px 8px',
						marginRight: '-8px',
					}}
				>
					&times;
				</button>
			</Modal.Header>
			<Modal.Body style={{ padding: 0 }}>
				{modalType === 'ISSUE_ALERT' && (
					<ServiceModalIssueAlert
						alert={currentAlert}
						onClose={HideModal}
					/>
				)}
				{modalType === 'NEW_TICKET' && (
					<ServiceModalNewTicket
						alert={currentAlert}
						onClose={HideModal}
					/>
				)}
			</Modal.Body>
			{modalType === 'ISSUE_ALERT' && <ServiceModalQueue />}
		</Modal>
	);
};

const mapState = (state) => ({
	showModal: state.ServiceModalReducer.showModal,
	modalType: state.ServiceModalReducer.modalType,
	currentAlert: state.ServiceModalReducer.currentAlert,
});

const mapDispatch = (dispatch) => ({
	HideModal: () => dispatch(ServiceModalAction.HideModal()),
});

export default connect(mapState, mapDispatch)(ServiceModalPopup);
